import { useParams } from 'react-router';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useEffect } from 'react';

import { Layout } from 'CorePackage/MainModule/components/Layout';
import { KnmRegistryTypeEnum } from 'APIPackage/KnmModule/enums/KnmRegistryTypeEnum';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IKnmRegistryItem } from 'APIPackage/KnmModule/interfaces/IKnmRegistryItem';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { RegistryInfo } from './RegistryInfo';
import { knmRegistryGetData } from '../actions/knmRegistryActions';

interface IRegistryInfoPage {
  registryInfoItems: IKnmRegistryItem[];
  getRegistryInfo: (id: string, registryName: string) => void;
}

export const RegistryInfoPageWithoutStore = ({ getRegistryInfo, registryInfoItems }: IRegistryInfoPage) => {
  const { id } = useParams<{ id: string }>();
  const path = window.location.pathname.split('/');
  const registryType = path[path.length - 2] as keyof typeof KnmRegistryTypeEnum;
  const registryName = KnmRegistryTypeEnum[registryType.toUpperCase() as keyof typeof KnmRegistryTypeEnum];

  useEffect(() => {
    getRegistryInfo(id, registryName);
  }, [getRegistryInfo, id, registryName]);

  return (
    <Layout withFooter>
      <RegistryInfo id={id} infoItems={registryInfoItems} registryName={registryName} registryType={registryType} />
    </Layout>
  );
};

const mapStateToProps = (state: IRootState) => ({
  registryInfoItems: state.knmRegistry.data,
});

const mapDispatchToProps = (dispatch: Dispatch<RootActions>) => ({
  getRegistryInfo: (id: string, registryName: string) => dispatch(knmRegistryGetData(id, registryName)),
});

export const RegistryInfoPage = connect(mapStateToProps, mapDispatchToProps)(RegistryInfoPageWithoutStore);
